import { FieldPattern } from '..';

import { MULTI_SELECT_CHECKBOX_GROUP } from '../../../../constants/FieldTypeConstants';
import {
  DropdownOptionsType,
  FormFieldsType
} from '../../../../types/FieldModelTypes';

import FormFieldWithInitialValue from '../FormFieldWithInitialValue';

class MultiSelectCheckboxGroupField extends FormFieldWithInitialValue {
  readonly type: string = MULTI_SELECT_CHECKBOX_GROUP;
  options!: Array<DropdownOptionsType>;
  isFieldDisabled!: boolean;

  constructor(multiSelectCheckboxGroupData: FormFieldsType, initialValue = '') {
    super(multiSelectCheckboxGroupData, initialValue);
    this.options = this.getOptions(
      multiSelectCheckboxGroupData.options as Array<string>
    );
    this.isFieldDisabled = false;
  }

  getOptions = (optionsArray: Array<string>): Array<DropdownOptionsType> =>
    optionsArray.map((eachOption) => ({
      value: eachOption,
      label: eachOption
    }));

  match<T>(p: FieldPattern<T>): T {
    return p.MultiSelectCheckboxGroupField(this);
  }
}

export default MultiSelectCheckboxGroupField;
